import type { TypeNames, GVariantOf } from 'variant';
import { variant, onTerms, payload, nil } from 'variant';

export const Result = variant(
  onTerms(({ T }) => ({
    Error: payload(T),
    Ok: nil,
  }))
);

export type Result<
  T,
  TType extends TypeNames<typeof Result> = undefined,
> = GVariantOf<typeof Result, TType, { T: T }>;
